function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from '@cloudflare/style-container';
import { Box } from '@cloudflare/component-box';

import { ThemedInput as Input } from './ThemedInput';

var InputLabel = createComponent(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.colors.gray[3],
    textAlign: 'center',
    backgroundColor: theme.colors.gray[9],
    borderTop: '1px solid ' + theme.colors.gray[5],
    borderBottom: '1px solid ' + theme.colors.gray[5],
    borderLeft: '1px solid ' + theme.colors.gray[5],
    whiteSpace: 'nowrap',
    marginRight: -1,
    borderTopLeftRadius: 2,
    borderBottomLeftRadius: 2,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: '0.75rem',
    fontSize: '0.86667rem',
    display: 'table-cell',
    verticalAlign: 'middle',
    height: theme.inputHeight
  };
});
InputLabel.setDisplayName('InputLabel');

var LabeledInput = function LabeledInput(_ref2) {
  var label = _ref2.label,
      otherProps = _objectWithoutProperties(_ref2, ['label']);

  return React.createElement(
    Box,
    { display: 'flex', width: '100%' },
    label && React.createElement(
      Box,
      null,
      React.createElement(
        InputLabel,
        null,
        label
      )
    ),
    React.createElement(
      Box,
      { flexGrow: 1, position: 'relative', marginLeft: '-1px' },
      React.createElement(Input, otherProps)
    )
  );
};
LabeledInput.displayName = 'LabeledInput';

LabeledInput.propTypes = {
  label: PropTypes.string
};

export default LabeledInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-input/es/LabeledInput.js
// module id = 1098
// module chunks = 1